'use client';

export default function PrivacyPolicy() {
  return (
    <main className="px-24 my-12 lg:px-6 lg:pr-10 lg:pt-4 dark:bg-background-dark">
      <div className="mx-auto my-6">
        <h1 className="mt-2 text-2xl font-bold tracking-tight sm:text-4xl">Privacy Policy</h1>
        <p className="mt-6 text-lg leading-8">
          Last Updated: February 10, 2025
        </p>
      </div>

      <div className="mx-auto my-6">
        <h2 className="mt-2 text-xl font-bold tracking-tight sm:text-2xl">1. Introduction</h2>
        <p className="mt-6 text-lg leading-8">
          SupplySense 360 provides AI-powered real-time shipment tracking, smart quotations, and predictive analytics services for optimal supply chain performance. This policy explains how we handle your data when you use our platform.
        </p>
      </div>

      <div className="mx-auto my-6">
        <h2 className="mt-2 text-xl font-bold tracking-tight sm:text-2xl">2. Information We Collect</h2>
        <div className="mt-6 text-lg leading-8 space-y-4">
          <p><strong>Account Information:</strong> Email address, name, company details, and login credentials.</p>
          <p><strong>Platform Data:</strong> Shipment tracking information, quotations, and EDI/API integration data.</p>
          <p><strong>Technical Data:</strong> IP address, device information, and usage statistics.</p>
        </div>
      </div>

      <div className="mx-auto my-6">
        <h2 className="mt-2 text-xl font-bold tracking-tight sm:text-2xl">3. How We Use Your Information</h2>
        <div className="mt-6 text-lg leading-8 space-y-4">
          <p><strong>Core Services:</strong> Providing shipment tracking, processing quotations, perform landed cost calculations, and sending status alerts.</p>
          <p><strong>Platform Improvement:</strong> Analyzing usage patterns and enhancing features.</p>
          <p><strong>Communication:</strong> Sending system notifications, service updates, and marketing content.</p>
        </div>
      </div>

      <div className="mx-auto my-6">
        <h2 className="mt-2 text-xl font-bold tracking-tight sm:text-2xl">4. Data Sharing</h2>
        <div className="mt-6 text-lg leading-8 space-y-4">
          <p><strong>Service Providers:</strong> We share data with trusted providers who help operate our platform.</p>
          <p><strong>Legal Requirements:</strong> We may disclose information when required by law.</p>
        </div>
      </div>

      <div className="mx-auto my-6">
        <h2 className="mt-2 text-xl font-bold tracking-tight sm:text-2xl">5. Security</h2>
        <p className="mt-6 text-lg leading-8">
          We implement industry-standard security measures to protect your data, including encryption and access controls.
        </p>
      </div>

      <div className="mx-auto my-6">
        <h2 className="mt-2 text-xl font-bold tracking-tight sm:text-2xl">6. Your Rights</h2>
        <div className="mt-6 text-lg leading-8 space-y-4">
          <p>You can access, correct, or request your personal information to be deleted on the Demo environment. Contact us to exercise these rights. </p>
          <p>For production / QA use, reachout to the SupplySense 360 champion at your organization to manage your account.</p>
        </div>
      </div>

      <div className="mx-auto my-6">
        <h2 className="mt-2 text-xl font-bold tracking-tight sm:text-2xl">7. Cookies</h2>
        <p className="mt-6 text-lg leading-8">
          We use cookies for platform functionality and analytics. Manage preferences through your browser settings.
        </p>
      </div>

      <div className="mx-auto my-6">
        <h2 className="mt-2 text-xl font-bold tracking-tight sm:text-2xl">8. Updates to Policy</h2>
        <p className="mt-6 text-lg leading-8">
          We may update this policy periodically. Significant changes will be notified via email or platform notification.
        </p>
      </div>

      <div className="mx-auto my-6">
        <h2 className="mt-2 text-xl font-bold tracking-tight sm:text-2xl">9. Contact Us</h2>
        <p className="mt-6 text-lg leading-8">
          For privacy-related questions, contact us at <a href="mailto:privacy@supplysense360.com"
className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300">privacy@supplysense360.com</a>
        </p>
      </div>
    </main>
  );
}